import type { UploadTicket } from '@painpal/contracts';
import type { Dispatch } from 'react';
import { putFile, requestUploads } from '../../api/uploads';
import { errorMessage } from '../../lib/api';
import type { UploadAction, UploadItem } from './uploadQueue';

async function uploadOne(item: UploadItem, ticket: UploadTicket | undefined, dispatch: Dispatch<UploadAction>): Promise<void> {
  if (ticket === undefined) {
    dispatch({ type: 'error', id: item.id, message: 'The server did not return an upload URL for this file' });
    return;
  }
  dispatch({ type: 'ticket', id: item.id, key: ticket.key });
  try {
    await putFile(ticket.uploadUrl, item.file);
    dispatch({ type: 'uploaded', id: item.id });
  } catch (error) {
    dispatch({ type: 'error', id: item.id, message: errorMessage(error) });
  }
}

export async function startUploads(batch: UploadItem[], dispatch: Dispatch<UploadAction>): Promise<void> {
  if (batch.length === 0) return;
  let tickets: UploadTicket[];
  try {
    tickets = (await requestUploads(batch.map((item) => item.file))).uploads;
  } catch (error) {
    batch.forEach((item) => dispatch({ type: 'error', id: item.id, message: errorMessage(error) }));
    return;
  }
  await Promise.all(batch.map((item, index) => uploadOne(item, tickets[index], dispatch)));
}
